export const IMimeTypeMap = [
    { extension: '.323', type: 'text/h323'},
    { extension: '.3g2', type: 'video/3gpp2'},
    { extension: '.3gp', type: 'video/3gpp'},
    { extension: '.3gp2', type: 'video/3gpp2'},
    { extension: '.3gpp', type: 'video/3gpp'},
    { extension: '.7z', type: 'application/x-7z-compressed'},
    { extension: '.aa', type: 'audio/audible'},
    { extension: '.AAC', type: 'audio/aac'},
    { extension: '.aaf', type: 'application/octet-stream'},
    { extension: '.aax', type: 'audio/vnd.audible.aax'},
    { extension: '.ac3', type: 'audio/ac3'},
    { extension: '.aca', type: 'application/octet-stream'},
    { extension: '.accda', type: 'application/msaccess.addin'},
    { extension: '.accdb', type: 'application/msaccess'},
    { extension: '.accdc', type: 'application/msaccess.cab'},
    { extension: '.accde', type: 'application/msaccess'},
    { extension: '.accdr', type: 'application/msaccess.runtime'},
    { extension: '.accdt', type: 'application/msaccess'},
    { extension: '.accdw', type: 'application/msaccess.webapplication'},
    { extension: '.accft', type: 'application/msaccess.ftemplate'},
    { extension: '.acx', type: 'application/internet-property-stream'},
    { extension: '.AddIn', type: 'text/xml'},
    { extension: '.ade', type: 'application/msaccess'},
    { extension: '.adobebridge', type: 'application/x-bridge-url'},
    { extension: '.adp', type: 'application/msaccess'},
    { extension: '.ADT', type: 'audio/vnd.dlna.adts'},
    { extension: '.ADTS', type: 'audio/aac'},
    { extension: '.afm', type: 'application/octet-stream'},
    { extension: '.ai', type: 'application/postscript'},
    { extension: '.aif', type: 'audio/aiff'},
    { extension: '.aifc', type: 'audio/aiff'},
    { extension: '.aiff', type: 'audio/aiff'},
    { extension: '.air', type: 'application/vnd.adobe.air-application-installer-package+zip'},
    { extension: '.amc', type: 'application/mpeg'},
    { extension: '.anx', type: 'application/annodex'},
    { extension: '.apk', type: 'application/vnd.android.package-archive' },
    { extension: '.application', type: 'application/x-ms-application'},
    { extension: '.art', type: 'image/x-jg'},
    { extension: '.asa', type: 'application/xml'},
    { extension: '.asax', type: 'application/xml'},
    { extension: '.ascx', type: 'application/xml'},
    { extension: '.asd', type: 'application/octet-stream'},
    { extension: '.asf', type: 'video/x-ms-asf'},
    { extension: '.ashx', type: 'application/xml'},
    { extension: '.asi', type: 'application/octet-stream'},
    { extension: '.asm', type: 'text/plain'},
    { extension: '.asmx', type: 'application/xml'},
    { extension: '.aspx', type: 'application/xml'},
    { extension: '.asr', type: 'video/x-ms-asf'},
    { extension: '.asx', type: 'video/x-ms-asf'},
    { extension: '.atom', type: 'application/atom+xml'},
    { extension: '.au', type: 'audio/basic'},
    { extension: '.avi', type: 'video/x-msvideo'},
    { extension: '.axa', type: 'audio/annodex'},
    { extension: '.axs', type: 'application/olescript'},
    { extension: '.axv', type: 'video/annodex'},
    { extension: '.bas', type: 'text/plain'},
    { extension: '.bcpio', type: 'application/x-bcpio'},
    { extension: '.bin', type: 'application/octet-stream'},
    { extension: '.bmp', type: 'image/bmp'},
    { extension: '.c', type: 'text/plain'},
    { extension: '.cab', type: 'application/octet-stream'},
    { extension: '.caf', type: 'audio/x-caf'},
    { extension: '.calx', type: 'application/vnd.ms-office.calx'},
    { extension: '.cat', type: 'application/vnd.ms-pki.seccat'},
    { extension: '.cc', type: 'text/plain'},
    { extension: '.cd', type: 'text/plain'},
    { extension: '.cdda', type: 'audio/aiff'},
    { extension: '.cdf', type: 'application/x-cdf'},
    { extension: '.cer', type: 'application/x-x509-ca-cert'},
    { extension: '.cfg', type: 'text/plain'},
    { extension: '.chm', type: 'application/octet-stream'},
    { extension: '.class', type: 'application/x-java-applet'},
    { extension: '.clp', type: 'application/x-msclip'},
    { extension: '.cmd', type: 'text/plain'},
    { extension: '.cmx', type: 'image/x-cmx'},
    { extension: '.cnf', type: 'text/plain'},
    { extension: '.cod', type: 'image/cis-cod'},
    { extension: '.config', type: 'application/xml'},
    { extension: '.contact', type: 'text/x-ms-contact'},
    { extension: '.coverage', type: 'application/xml'},
    { extension: '.cpio', type: 'application/x-cpio'},
    { extension: '.cpp', type: 'text/plain'},
    { extension: '.crd', type: 'application/x-mscardfile'},
    { extension: '.crl', type: 'application/pkix-crl'},
    { extension: '.crt', type: 'application/x-x509-ca-cert'},
    { extension: '.cs', type: 'text/plain'},
    { extension: '.csdproj', type: 'text/plain'},
    { extension: '.csh', type: 'application/x-csh'},
    { extension: '.csproj', type: 'text/plain'},
    { extension: '.css', type: 'text/css'},
    { extension: '.csv', type: 'text/csv'},
    { extension: '.cur', type: 'application/octet-stream'},
    { extension: '.cxx', type: 'text/plain'},
    { extension: '.dat', type: 'application/octet-stream'},
    { extension: '.datasource', type: 'application/xml'},
    { extension: '.dbproj', type: 'text/plain'},
    { extension: '.dcr', type: 'application/x-director'},
    { extension: '.def', type: 'text/plain'},
    { extension: '.deploy', type: 'application/octet-stream'},
    { extension: '.der', type: 'application/x-x509-ca-cert'},
    { extension: '.dgml', type: 'application/xml'},
    { extension: '.dib', type: 'image/bmp'},
    { extension: '.dif', type: 'video/x-dv'},
    { extension: '.dir', type: 'application/x-director'},
    { extension: '.disco', type: 'text/xml'},
    { extension: '.divx', type: 'video/divx'},
    { extension: '.dll', type: 'application/x-msdownload'},
    { extension: '.dll.config', type: 'text/xml'},
    { extension: '.dlm', type: 'text/dlm'},
    { extension: '.doc', type: 'application/msword'},
    { extension: '.docm', type: 'application/vnd.ms-word.document.macroEnabled.12'},
    { extension: '.docx', type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'},
    { extension: '.dot', type: 'application/msword'},
    { extension: '.dotm', type: 'application/vnd.ms-word.template.macroEnabled.12'},
    { extension: '.dotx', type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template'},
    { extension: '.dsp', type: 'application/octet-stream'},
    { extension: '.dsw', type: 'text/plain'},
    { extension: '.dtd', type: 'text/xml'},
    { extension: '.dtsConfig', type: 'text/xml'},
    { extension: '.dv', type: 'video/x-dv'},
    { extension: '.dvi', type: 'application/x-dvi'},
    { extension: '.dwf', type: 'drawing/x-dwf'},
    { extension: '.dwg', type: 'application/acad'},
    { extension: '.dwp', type: 'application/octet-stream'},
    { extension: '.dxf', type: 'application/x-dxf' },
    { extension: '.dxr', type: 'application/x-director'},
    { extension: '.eml', type: 'message/rfc822'},
    { extension: '.emz', type: 'application/octet-stream'},
    { extension: '.eot', type: 'application/vnd.ms-fontobject'},
    { extension: '.eps', type: 'application/postscript'},
    { extension: '.es', type: 'application/ecmascript'},
    { extension: '.etl', type: 'application/etl'},
    { extension: '.etx', type: 'text/x-setext'},
    { extension: '.evy', type: 'application/envoy'},
    { extension: '.exe', type: 'application/octet-stream'},
    { extension: '.exe.config', type: 'text/xml'},
    { extension: '.fdf', type: 'application/vnd.fdf'},
    { extension: '.fif', type: 'application/fractals'},
    { extension: '.filters', type: 'application/xml'},
    { extension: '.fla', type: 'application/octet-stream'},
    { extension: '.flac', type: 'audio/flac'},
    { extension: '.flr', type: 'x-world/x-vrml'},
    { extension: '.flv', type: 'video/x-flv'},
    { extension: '.fsscript', type: 'application/fsharp-script'},
    { extension: '.fsx', type: 'application/fsharp-script'},
    { extension: '.generictest', type: 'application/xml'},
    { extension: '.gif', type: 'image/gif'},
    { extension: '.gpx', type: 'application/gpx+xml'},
    { extension: '.group', type: 'text/x-ms-group'},
    { extension: '.gsm', type: 'audio/x-gsm'},
    { extension: '.gtar', type: 'application/x-gtar'},
    { extension: '.gz', type: 'application/x-gzip'},
    { extension: '.h', type: 'text/plain'},
    { extension: '.hdf', type: 'application/x-hdf'},
    { extension: '.hdml', type: 'text/x-hdml'},
    { extension: '.hhc', type: 'application/x-oleobject'},
    { extension: '.hhk', type: 'application/octet-stream'},
    { extension: '.hhp', type: 'application/octet-stream'},
    { extension: '.hlp', type: 'application/winhlp'},
    { extension: '.hpp', type: 'text/plain'},
    { extension: '.hqx', type: 'application/mac-binhex40'},
    { extension: '.hta', type: 'application/hta'},
    { extension: '.htc', type: 'text/x-component'},
    { extension: '.htm', type: 'text/html'},
    { extension: '.html', type: 'text/html'},
    { extension: '.htt', type: 'text/webviewhtml'},
    { extension: '.hxa', type: 'application/xml'},
    { extension: '.hxc', type: 'application/xml'},
    { extension: '.hxd', type: 'application/octet-stream'},
    { extension: '.hxe', type: 'application/xml'},
    { extension: '.hxf', type: 'application/xml'},
    { extension: '.hxh', type: 'application/octet-stream'},
    { extension: '.hxi', type: 'application/octet-stream'},
    { extension: '.hxk', type: 'application/xml'},
    { extension: '.hxq', type: 'application/octet-stream'},
    { extension: '.hxr', type: 'application/octet-stream'},
    { extension: '.hxs', type: 'application/octet-stream'},
    { extension: '.hxt', type: 'text/html'},
    { extension: '.hxv', type: 'application/xml'},
    { extension: '.hxw', type: 'application/octet-stream'},
    { extension: '.hxx', type: 'text/plain'},
    { extension: '.i', type: 'text/plain'},
    { extension: '.ico', type: 'image/x-icon'},
    { extension: '.ics', type: 'application/octet-stream'},
    { extension: '.idl', type: 'text/plain'},
    { extension: '.ief', type: 'image/ief'},
    { extension: '.iii', type: 'application/x-iphone'},
    { extension: '.inc', type: 'text/plain'},
    { extension: '.inf', type: 'application/octet-stream'},
    { extension: '.ini', type: 'text/plain'},
    { extension: '.inl', type: 'text/plain'},
    { extension: '.ins', type: 'application/x-internet-signup'},
    { extension: '.ipa', type: 'application/x-itunes-ipa'},
    { extension: '.ipg', type: 'application/x-itunes-ipg'},
    { extension: '.ipproj', type: 'text/plain'},
    { extension: '.ipsw', type: 'application/x-itunes-ipsw'},
    { extension: '.iqy', type: 'text/x-ms-iqy'},
    { extension: '.isp', type: 'application/x-internet-signup'},
    { extension: '.ite', type: 'application/x-itunes-ite'},
    { extension: '.itlp', type: 'application/x-itunes-itlp'},
    { extension: '.itms', type: 'application/x-itunes-itms'},
    { extension: '.itpc', type: 'application/x-itunes-itpc'},
    { extension: '.IVF', type: 'video/x-ivf'},
    { extension: '.jar', type: 'application/java-archive'},
    { extension: '.java', type: 'application/octet-stream'},
    { extension: '.jck', type: 'application/liquidmotion'},
    { extension: '.jcz', type: 'application/liquidmotion'},
    { extension: '.jfif', type: 'image/pjpeg'},
    { extension: '.jnlp', type: 'application/x-java-jnlp-file'},
    { extension: '.jpb', type: 'application/octet-stream'},
    { extension: '.jpe', type: 'image/jpeg'},
    { extension: '.jpeg', type: 'image/jpeg'},
    { extension: '.jpg', type: 'image/jpeg'},
    { extension: '.js', type: 'application/javascript'},
    { extension: '.json', type: 'application/json'},
    { extension: '.jsx', type: 'text/jscript'},
    { extension: '.jsxbin', type: 'text/plain'},
    { extension: '.latex', type: 'application/x-latex'},
    { extension: '.library-ms', type: 'application/windows-library+xml'},
    { extension: '.lit', type: 'application/x-ms-reader'},
    { extension: '.loadtest', type: 'application/xml'},
    { extension: '.lpk', type: 'application/octet-stream'},
    { extension: '.lsf', type: 'video/x-la-asf'},
    { extension: '.lst', type: 'text/plain'},
    { extension: '.lsx', type: 'video/x-la-asf'},
    { extension: '.lzh', type: 'application/octet-stream'},
    { extension: '.m13', type: 'application/x-msmediaview'},
    { extension: '.m14', type: 'application/x-msmediaview'},
    { extension: '.m1v', type: 'video/mpeg'},
    { extension: '.m2t', type: 'video/vnd.dlna.mpeg-tts'},
    { extension: '.m2ts', type: 'video/vnd.dlna.mpeg-tts'},
    { extension: '.m2v', type: 'video/mpeg'},
    { extension: '.m3u', type: 'audio/x-mpegurl'},
    { extension: '.m3u8', type: 'audio/x-mpegurl'},
    { extension: '.m4a', type: 'audio/m4a'},
    { extension: '.m4b', type: 'audio/m4b'},
    { extension: '.m4p', type: 'audio/m4p'},
    { extension: '.m4r', type: 'audio/x-m4r'},
    { extension: '.m4v', type: 'video/x-m4v'},
    { extension: '.mac', type: 'image/x-macpaint'},
    { extension: '.mak', type: 'text/plain'},
    { extension: '.man', type: 'application/x-troff-man'},
    { extension: '.manifest', type: 'application/x-ms-manifest'},
    { extension: '.map', type: 'text/plain'},
    { extension: '.master', type: 'application/xml'},
    { extension: '.mbox', type: 'application/mbox'},
    { extension: '.mda', type: 'application/msaccess'},
    { extension: '.mdb', type: 'application/x-msaccess'},
    { extension: '.mde', type: 'application/msaccess'},
    { extension: '.mdp', type: 'application/octet-stream'},
    { extension: '.me', type: 'application/x-troff-me'},
    { extension: '.mfp', type: 'application/x-shockwave-flash'},
    { extension: '.mht', type: 'message/rfc822'},
    { extension: '.mhtml', type: 'message/rfc822'},
    { extension: '.mid', type: 'audio/mid'},
    { extension: '.midi', type: 'audio/mid'},
    { extension: '.mix', type: 'application/octet-stream'},
    { extension: '.mk', type: 'text/plain'},
    { extension: '.mk3d', type: 'video/x-matroska-3d'},
    { extension: '.mka', type: 'audio/x-matroska'},
    { extension: '.mkv', type: 'video/x-matroska'},
    { extension: '.mmf', type: 'application/x-smaf'},
    { extension: '.mno', type: 'text/xml'},
    { extension: '.mny', type: 'application/x-msmoney'},
    { extension: '.mod', type: 'video/mpeg'},
    { extension: '.mov', type: 'video/quicktime'},
    { extension: '.movie', type: 'video/x-sgi-movie'},
    { extension: '.mp2', type: 'video/mpeg'},
    { extension: '.mp2v', type: 'video/mpeg'},
    { extension: '.mp3', type: 'audio/mpeg'},
    { extension: '.mp4', type: 'video/mp4'},
    { extension: '.mp4v', type: 'video/mp4'},
    { extension: '.mpa', type: 'video/mpeg'},
    { extension: '.mpe', type: 'video/mpeg'},
    { extension: '.mpeg', type: 'video/mpeg'},
    { extension: '.mpf', type: 'application/vnd.ms-mediapackage'},
    { extension: '.mpg', type: 'video/mpeg'},
    { extension: '.mpp', type: 'application/vnd.ms-project'},
    { extension: '.mpv2', type: 'video/mpeg'},
    { extension: '.mqv', type: 'video/quicktime'},
    { extension: '.ms', type: 'application/x-troff-ms'},
    { extension: '.msg', type: 'application/vnd.ms-outlook'},
    { extension: '.msi', type: 'application/octet-stream'},
    { extension: '.mso', type: 'application/octet-stream'},
    { extension: '.mts', type: 'video/vnd.dlna.mpeg-tts'},
    { extension: '.mtx', type: 'application/xml'},
    { extension: '.mvb', type: 'application/x-msmediaview'},
    { extension: '.mvc', type: 'application/x-miva-compiled'},
    { extension: '.mxp', type: 'application/x-mmxp'},
    { extension: '.nc', type: 'application/x-netcdf'},
    { extension: '.nsc', type: 'video/x-ms-asf'},
    { extension: '.nws', type: 'message/rfc822'},
    { extension: '.ocx', type: 'application/octet-stream'},
    { extension: '.oda', type: 'application/oda'},
    { extension: '.odb', type: 'application/vnd.oasis.opendocument.database'},
    { extension: '.odc', type: 'application/vnd.oasis.opendocument.chart'},
    { extension: '.odf', type: 'application/vnd.oasis.opendocument.formula'},
    { extension: '.odg', type: 'application/vnd.oasis.opendocument.graphics'},
    { extension: '.odh', type: 'text/plain'},
    { extension: '.odi', type: 'application/vnd.oasis.opendocument.image'},
    { extension: '.odl', type: 'text/plain'},
    { extension: '.odm', type: 'application/vnd.oasis.opendocument.text-master'},
    { extension: '.odp', type: 'application/vnd.oasis.opendocument.presentation'},
    { extension: '.ods', type: 'application/vnd.oasis.opendocument.spreadsheet'},
    { extension: '.odt', type: 'application/vnd.oasis.opendocument.text'},
    { extension: '.oga', type: 'audio/ogg'},
    { extension: '.ogg', type: 'audio/ogg'},
    { extension: '.ogv', type: 'video/ogg'},
    { extension: '.ogx', type: 'application/ogg'},
    { extension: '.one', type: 'application/onenote'},
    { extension: '.onea', type: 'application/onenote'},
    { extension: '.onepkg', type: 'application/onenote'},
    { extension: '.onetmp', type: 'application/onenote'},
    { extension: '.onetoc', type: 'application/onenote'},
    { extension: '.onetoc2', type: 'application/onenote'},
    { extension: '.opus', type: 'audio/ogg'},
    { extension: '.orderedtest', type: 'application/xml'},
    { extension: '.osdx', type: 'application/opensearchdescription+xml'},
    { extension: '.otf', type: 'application/font-sfnt'},
    { extension: '.otg', type: 'application/vnd.oasis.opendocument.graphics-template'},
    { extension: '.oth', type: 'application/vnd.oasis.opendocument.text-web'},
    { extension: '.otp', type: 'application/vnd.oasis.opendocument.presentation-template'},
    { extension: '.ots', type: 'application/vnd.oasis.opendocument.spreadsheet-template'},
    { extension: '.ott', type: 'application/vnd.oasis.opendocument.text-template'},
    { extension: '.oxt', type: 'application/vnd.openofficeorg.extension'},
    { extension: '.p10', type: 'application/pkcs10'},
    { extension: '.p12', type: 'application/x-pkcs12'},
    { extension: '.p7b', type: 'application/x-pkcs7-certificates'},
    { extension: '.p7c', type: 'application/pkcs7-mime'},
    { extension: '.p7m', type: 'application/pkcs7-mime'},
    { extension: '.p7r', type: 'application/x-pkcs7-certreqresp'},
    { extension: '.p7s', type: 'application/pkcs7-signature'},
    { extension: '.pbm', type: 'image/x-portable-bitmap'},
    { extension: '.pcast', type: 'application/x-podcast'},
    { extension: '.pct', type: 'image/pict'},
    { extension: '.pcx', type: 'application/octet-stream'},
    { extension: '.pcz', type: 'application/octet-stream'},
    { extension: '.pdf', type: 'application/pdf'},
    { extension: '.pfb', type: 'application/octet-stream'},
    { extension: '.pfm', type: 'application/octet-stream'},
    { extension: '.pfx', type: 'application/x-pkcs12'},
    { extension: '.pgm', type: 'image/x-portable-graymap'},
    { extension: '.pic', type: 'image/pict'},
    { extension: '.pict', type: 'image/pict'},
    { extension: '.pkgdef', type: 'text/plain'},
    { extension: '.pkgundef', type: 'text/plain'},
    { extension: '.pko', type: 'application/vnd.ms-pki.pko'},
    { extension: '.pls', type: 'audio/scpls'},
    { extension: '.pma', type: 'application/x-perfmon'},
    { extension: '.pmc', type: 'application/x-perfmon'},
    { extension: '.pml', type: 'application/x-perfmon'},
    { extension: '.pmr', type: 'application/x-perfmon'},
    { extension: '.pmw', type: 'application/x-perfmon'},
    { extension: '.png', type: 'image/png'},
    { extension: '.pnm', type: 'image/x-portable-anymap'},
    { extension: '.pnt', type: 'image/x-macpaint'},
    { extension: '.pntg', type: 'image/x-macpaint'},
    { extension: '.pnz', type: 'image/png'},
    { extension: '.pot', type: 'application/vnd.ms-powerpoint'},
    { extension: '.potm', type: 'application/vnd.ms-powerpoint.template.macroEnabled.12'},
    { extension: '.potx', type: 'application/vnd.openxmlformats-officedocument.presentationml.template'},
    { extension: '.ppa', type: 'application/vnd.ms-powerpoint'},
    { extension: '.ppam', type: 'application/vnd.ms-powerpoint.addin.macroEnabled.12'},
    { extension: '.ppm', type: 'image/x-portable-pixmap'},
    { extension: '.pps', type: 'application/vnd.ms-powerpoint'},
    { extension: '.ppsm', type: 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'},
    { extension: '.ppsx', type: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow'},
    { extension: '.ppt', type: 'application/vnd.ms-powerpoint'},
    { extension: '.pptm', type: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12'},
    { extension: '.pptx', type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'},
    { extension: '.prf', type: 'application/pics-rules'},
    { extension: '.prm', type: 'application/octet-stream'},
    { extension: '.prx', type: 'application/octet-stream'},
    { extension: '.ps', type: 'application/postscript'},
    { extension: '.psc1', type: 'application/PowerShell'},
    { extension: '.psd', type: 'application/octet-stream'},
    { extension: '.psess', type: 'application/xml'},
    { extension: '.psm', type: 'application/octet-stream'},
    { extension: '.psp', type: 'application/octet-stream'},
    { extension: '.pst', type: 'application/vnd.ms-outlook'},
    { extension: '.pub', type: 'application/x-mspublisher'},
    { extension: '.pwz', type: 'application/vnd.ms-powerpoint'},
    { extension: '.qht', type: 'text/x-html-insertion'},
    { extension: '.qhtm', type: 'text/x-html-insertion'},
    { extension: '.qt', type: 'video/quicktime'},
    { extension: '.qti', type: 'image/x-quicktime'},
    { extension: '.qtif', type: 'image/x-quicktime'},
    { extension: '.qtl', type: 'application/x-quicktimeplayer'},
    { extension: '.qxd', type: 'application/octet-stream'},
    { extension: '.ra', type: 'audio/x-pn-realaudio'},
    { extension: '.ram', type: 'audio/x-pn-realaudio'},
    { extension: '.rar', type: 'application/x-rar-compressed'},
    { extension: '.ras', type: 'image/x-cmu-raster'},
    { extension: '.rat', type: 'application/rat-file'},
    { extension: '.rc', type: 'text/plain'},
    { extension: '.rc2', type: 'text/plain'},
    { extension: '.rct', type: 'text/plain'},
    { extension: '.rdlc', type: 'application/xml'},
    { extension: '.reg', type: 'text/plain'},
    { extension: '.resx', type: 'application/xml'},
    { extension: '.rf', type: 'image/vnd.rn-realflash'},
    { extension: '.rgb', type: 'image/x-rgb'},
    { extension: '.rgs', type: 'text/plain'},
    { extension: '.rm', type: 'application/vnd.rn-realmedia'},
    { extension: '.rmi', type: 'audio/mid'},
    { extension: '.rmp', type: 'application/vnd.rn-rn_music_package'},
    { extension: '.roff', type: 'application/x-troff'},
    { extension: '.rpm', type: 'audio/x-pn-realaudio-plugin'},
    { extension: '.rqy', type: 'text/x-ms-rqy'},
    { extension: '.rtf', type: 'application/rtf'},
    { extension: '.rtx', type: 'text/richtext'},
    { extension: '.rvt', type: 'application/octet-stream' },
    { extension: '.ruleset', type: 'application/xml'},
    { extension: '.s', type: 'text/plain'},
    { extension: '.safariextz', type: 'application/x-safari-safariextz'},
    { extension: '.scd', type: 'application/x-msschedule'},
    { extension: '.scr', type: 'text/plain'},
    { extension: '.sct', type: 'text/scriptlet'},
    { extension: '.sd2', type: 'audio/x-sd2'},
    { extension: '.sdp', type: 'application/sdp'},
    { extension: '.sea', type: 'application/octet-stream'},
    { extension: '.searchConnector-ms', type: 'application/windows-search-connector+xml'},
    { extension: '.setpay', type: 'application/set-payment-initiation'},
    { extension: '.setreg', type: 'application/set-registration-initiation'},
    { extension: '.settings', type: 'application/xml'},
    { extension: '.sgimb', type: 'application/x-sgimb'},
    { extension: '.sgml', type: 'text/sgml'},
    { extension: '.sh', type: 'application/x-sh'},
    { extension: '.shar', type: 'application/x-shar'},
    { extension: '.shtml', type: 'text/html'},
    { extension: '.sit', type: 'application/x-stuffit'},
    { extension: '.sitemap', type: 'application/xml'},
    { extension: '.skin', type: 'application/xml'},
    { extension: '.skp', type: 'application/x-koan' },
    { extension: '.sldm', type: 'application/vnd.ms-powerpoint.slide.macroEnabled.12'},
    { extension: '.sldx', type: 'application/vnd.openxmlformats-officedocument.presentationml.slide'},
    { extension: '.slk', type: 'application/vnd.ms-excel'},
    { extension: '.sln', type: 'text/plain'},
    { extension: '.slupkg-ms', type: 'application/x-ms-license'},
    { extension: '.smd', type: 'audio/x-smd'},
    { extension: '.smi', type: 'application/octet-stream'},
    { extension: '.smx', type: 'audio/x-smd'},
    { extension: '.smz', type: 'audio/x-smd'},
    { extension: '.snd', type: 'audio/basic'},
    { extension: '.snippet', type: 'application/xml'},
    { extension: '.snp', type: 'application/octet-stream'},
    { extension: '.sol', type: 'text/plain'},
    { extension: '.sor', type: 'text/plain'},
    { extension: '.spc', type: 'application/x-pkcs7-certificates'},
    { extension: '.spl', type: 'application/futuresplash'},
    { extension: '.spx', type: 'audio/ogg'},
    { extension: '.src', type: 'application/x-wais-source'},
    { extension: '.srf', type: 'text/plain'},
    { extension: '.SSISDeploymentManifest', type: 'text/xml'},
    { extension: '.ssm', type: 'application/streamingmedia'},
    { extension: '.sst', type: 'application/vnd.ms-pki.certstore'},
    { extension: '.stl', type: 'application/vnd.ms-pki.stl'},
    { extension: '.sv4cpio', type: 'application/x-sv4cpio'},
    { extension: '.sv4crc', type: 'application/x-sv4crc'},
    { extension: '.svc', type: 'application/xml'},
    { extension: '.svg', type: 'image/svg+xml'},
    { extension: '.swf', type: 'application/x-shockwave-flash'},
    { extension: '.step', type: 'application/step'},
    { extension: '.stp', type: 'application/step'},
    { extension: '.t', type: 'application/x-troff'},
    { extension: '.tar', type: 'application/x-tar'},
    { extension: '.tcl', type: 'application/x-tcl'},
    { extension: '.testrunconfig', type: 'application/xml'},
    { extension: '.testsettings', type: 'application/xml'},
    { extension: '.tex', type: 'application/x-tex'},
    { extension: '.texi', type: 'application/x-texinfo'},
    { extension: '.texinfo', type: 'application/x-texinfo'},
    { extension: '.tgz', type: 'application/x-compressed'},
    { extension: '.thmx', type: 'application/vnd.ms-officetheme'},
    { extension: '.thn', type: 'application/octet-stream'},
    { extension: '.tif', type: 'image/tiff'},
    { extension: '.tiff', type: 'image/tiff'},
    { extension: '.tlh', type: 'text/plain'},
    { extension: '.tli', type: 'text/plain'},
    { extension: '.toc', type: 'application/octet-stream'},
    { extension: '.tr', type: 'application/x-troff'},
    { extension: '.trm', type: 'application/x-msterminal'},
    { extension: '.trx', type: 'application/xml'},
    { extension: '.ts', type: 'video/vnd.dlna.mpeg-tts'},
    { extension: '.tsv', type: 'text/tab-separated-values'},
    { extension: '.ttf', type: 'application/font-sfnt'},
    { extension: '.tts', type: 'video/vnd.dlna.mpeg-tts'},
    { extension: '.txt', type: 'text/plain'},
    { extension: '.u32', type: 'application/octet-stream'},
    { extension: '.uls', type: 'text/iuls'},
    { extension: '.user', type: 'text/plain'},
    { extension: '.ustar', type: 'application/x-ustar'},
    { extension: '.vb', type: 'text/plain'},
    { extension: '.vbdproj', type: 'text/plain'},
    { extension: '.vbk', type: 'video/mpeg'},
    { extension: '.vbproj', type: 'text/plain'},
    { extension: '.vbs', type: 'text/vbscript'},
    { extension: '.vcf', type: 'text/x-vcard'},
    { extension: '.vcproj', type: 'application/xml'},
    { extension: '.vcs', type: 'text/plain'},
    { extension: '.vcxproj', type: 'application/xml'},
    { extension: '.vddproj', type: 'text/plain'},
    { extension: '.vdp', type: 'text/plain'},
    { extension: '.vdproj', type: 'text/plain'},
    { extension: '.vdx', type: 'application/vnd.ms-visio.viewer'},
    { extension: '.vml', type: 'text/xml'},
    { extension: '.vscontent', type: 'application/xml'},
    { extension: '.vsct', type: 'text/xml'},
    { extension: '.vsd', type: 'application/vnd.visio'},
    { extension: '.vsi', type: 'application/ms-vsi'},
    { extension: '.vsix', type: 'application/vsix'},
    { extension: '.vsixlangpack', type: 'text/xml'},
    { extension: '.vsixmanifest', type: 'text/xml'},
    { extension: '.vsmdi', type: 'application/xml'},
    { extension: '.vspscc', type: 'text/plain'},
    { extension: '.vss', type: 'application/vnd.visio'},
    { extension: '.vsscc', type: 'text/plain'},
    { extension: '.vssettings', type: 'text/xml'},
    { extension: '.vssscc', type: 'text/plain'},
    { extension: '.vst', type: 'application/vnd.visio'},
    { extension: '.vstemplate', type: 'text/xml'},
    { extension: '.vsto', type: 'application/x-ms-vsto'},
    { extension: '.vsw', type: 'application/vnd.visio'},
    { extension: '.vsx', type: 'application/vnd.visio'},
    { extension: '.vtt', type: 'text/vtt'},
    { extension: '.vtx', type: 'application/vnd.visio'},
    { extension: '.wasm', type: 'application/wasm'},
    { extension: '.wav', type: 'audio/wav'},
    { extension: '.wave', type: 'audio/wav'},
    { extension: '.wax', type: 'audio/x-ms-wax'},
    { extension: '.wbk', type: 'application/msword'},
    { extension: '.wbmp', type: 'image/vnd.wap.wbmp'},
    { extension: '.wcm', type: 'application/vnd.ms-works'},
    { extension: '.wdb', type: 'application/vnd.ms-works'},
    { extension: '.wdp', type: 'image/vnd.ms-photo'},
    { extension: '.webarchive', type: 'application/x-safari-webarchive'},
    { extension: '.webm', type: 'video/webm'},
    { extension: '.webp', type: 'image/webp'}, /* https://en.wikipedia.org/wiki/WebP */
    { extension: '.webtest', type: 'application/xml'},
    { extension: '.wiq', type: 'application/xml'},
    { extension: '.wiz', type: 'application/msword'},
    { extension: '.wks', type: 'application/vnd.ms-works'},
    { extension: '.WLMP', type: 'application/wlmoviemaker'},
    { extension: '.wlpginstall', type: 'application/x-wlpg-detect'},
    { extension: '.wlpginstall3', type: 'application/x-wlpg3-detect'},
    { extension: '.wm', type: 'video/x-ms-wm'},
    { extension: '.wma', type: 'audio/x-ms-wma'},
    { extension: '.wmd', type: 'application/x-ms-wmd'},
    { extension: '.wmf', type: 'application/x-msmetafile'},
    { extension: '.wml', type: 'text/vnd.wap.wml'},
    { extension: '.wmlc', type: 'application/vnd.wap.wmlc'},
    { extension: '.wmls', type: 'text/vnd.wap.wmlscript'},
    { extension: '.wmlsc', type: 'application/vnd.wap.wmlscriptc'},
    { extension: '.wmp', type: 'video/x-ms-wmp'},
    { extension: '.wmv', type: 'video/x-ms-wmv'},
    { extension: '.wmx', type: 'video/x-ms-wmx'},
    { extension: '.wmz', type: 'application/x-ms-wmz'},
    { extension: '.woff', type: 'application/font-woff'},
    { extension: '.woff2', type: 'application/font-woff2'},
    { extension: '.wpl', type: 'application/vnd.ms-wpl'},
    { extension: '.wps', type: 'application/vnd.ms-works'},
    { extension: '.wri', type: 'application/x-mswrite'},
    { extension: '.wrl', type: 'x-world/x-vrml'},
    { extension: '.wrz', type: 'x-world/x-vrml'},
    { extension: '.wsc', type: 'text/scriptlet'},
    { extension: '.wsdl', type: 'text/xml'},
    { extension: '.wvx', type: 'video/x-ms-wvx'},
    { extension: '.x', type: 'application/directx'},
    { extension: '.xaf', type: 'x-world/x-vrml'},
    { extension: '.xaml', type: 'application/xaml+xml'},
    { extension: '.xap', type: 'application/x-silverlight-app'},
    { extension: '.xbap', type: 'application/x-ms-xbap'},
    { extension: '.xbm', type: 'image/x-xbitmap'},
    { extension: '.xdr', type: 'text/plain'},
    { extension: '.xht', type: 'application/xhtml+xml'},
    { extension: '.xhtml', type: 'application/xhtml+xml'},
    { extension: '.xla', type: 'application/vnd.ms-excel'},
    { extension: '.xlam', type: 'application/vnd.ms-excel.addin.macroEnabled.12'},
    { extension: '.xlc', type: 'application/vnd.ms-excel'},
    { extension: '.xld', type: 'application/vnd.ms-excel'},
    { extension: '.xlk', type: 'application/vnd.ms-excel'},
    { extension: '.xll', type: 'application/vnd.ms-excel'},
    { extension: '.xlm', type: 'application/vnd.ms-excel'},
    { extension: '.xls', type: 'application/vnd.ms-excel'},
    { extension: '.xlsb', type: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12'},
    { extension: '.xlsm', type: 'application/vnd.ms-excel.sheet.macroEnabled.12'},
    { extension: '.xlsx', type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
    { extension: '.xlt', type: 'application/vnd.ms-excel'},
    { extension: '.xltm', type: 'application/vnd.ms-excel.template.macroEnabled.12'},
    { extension: '.xltx', type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'},
    { extension: '.xlw', type: 'application/vnd.ms-excel'},
    { extension: '.xml', type: 'text/xml'},
    { extension: '.xmp', type: 'application/octet-stream' },
    { extension: '.xmta', type: 'application/xml'},
    { extension: '.xof', type: 'x-world/x-vrml'},
    { extension: '.XOML', type: 'text/plain'},
    { extension: '.xpm', type: 'image/x-xpixmap'},
    { extension: '.xps', type: 'application/vnd.ms-xpsdocument'},
    { extension: '.xrm-ms', type: 'text/xml'},
    { extension: '.xsc', type: 'application/xml'},
    { extension: '.xsd', type: 'text/xml'},
    { extension: '.xsf', type: 'text/xml'},
    { extension: '.xsl', type: 'text/xml'},
    { extension: '.xslt', type: 'text/xml'},
    { extension: '.xsn', type: 'application/octet-stream'},
    { extension: '.xss', type: 'application/xml'},
    { extension: '.xspf', type: 'application/xspf+xml'},
    { extension: '.xtp', type: 'application/octet-stream'},
    { extension: '.xwd', type: 'image/x-xwindowdump'},
    { extension: '.z', type: 'application/x-compress'},
    { extension: '.zip', type: 'application/zip'},
    { extension: 'application/fsharp-script', type: '.fsx'},
    { extension: 'application/msaccess', type: '.adp'},
    { extension: 'application/msword', type: '.doc'},
    { extension: 'application/octet-stream', type: '.bin'},
    { extension: 'application/onenote', type: '.one'},
    { extension: 'application/postscript', type: '.eps'},
    { extension: 'application/step', type:  '.step'},
    { extension: 'application/vnd.ms-excel', type: '.xls'},
    { extension: 'application/vnd.ms-powerpoint', type: '.ppt'},
    { extension: 'application/vnd.ms-works', type: '.wks'},
    { extension: 'application/vnd.visio', type: '.vsd'},
    { extension: 'application/x-director', type: '.dir'},
    { extension: 'application/x-shockwave-flash', type: '.swf'},
    { extension: 'application/x-x509-ca-cert', type: '.cer'},
    { extension: 'application/x-zip-compressed', type: '.zip'},
    { extension: 'application/xhtml+xml', type: '.xhtml'},
    { extension: 'application/xml', type:  '.xml'},
    { extension: 'audio/aac', type: '.AAC'},
    { extension: 'audio/aiff', type: '.aiff'},
    { extension: 'audio/basic', type: '.snd'},
    { extension: 'audio/mid', type: '.midi'},
    { extension: 'audio/wav', type: '.wav'},
    { extension: 'audio/x-m4a', type: '.m4a'},
    { extension: 'audio/x-mpegur', type: '.m3u'},
    { extension: 'audio/x-pn-realaudio', type: '.ra'},
    { extension: 'audio/x-smd', type: '.smd'},
    { extension: 'image/bmp', type: '.bmp'},
    { extension: 'image/jpeg', type: '.jpg'},
    { extension: 'image/pict', type: '.pic'},
    { extension: 'image/png', type: '.png'},
    { extension: 'image/x-png', type: '.png'},
    { extension: 'image/tiff', type: '.tiff'},
    { extension: 'image/x-macpaint', type: '.mac'},
    { extension: 'image/x-quicktime', type: '.qti'},
    { extension: 'message/rfc822', type: '.eml'},
    { extension: 'text/html', type: '.html'},
    { extension: 'text/plain', type: '.txt'},
    { extension: 'text/scriptlet', type:  '.wsc'},
    { extension: 'text/xml', type: '.xml'},
    { extension: 'video/3gpp', type: '.3gp'},
    { extension: 'video/3gpp2', type: '.3gp2'},
    { extension: 'video/mp4', type: '.mp4'},
    { extension: 'video/mpeg', type: '.mpg'},
    { extension: 'video/quicktime', type:  '.mov'},
    { extension: 'video/vnd.dlna.mpeg-tts', type: '.m2t'},
    { extension: 'video/x-dv', type: '.dv'},
    { extension: 'video/x-la-asf', type: '.lsf'},
    { extension: 'video/x-ms-asf', type: '.asf'},
    { extension: 'x-world/x-vrml', type: '.xof'},
];

export interface ListaArchivosCargados {
    Nombre: string;
    Tamano: number;
    ClaveDocumento: number;
    PosicionArray: number;
    IdDocumento: number;
    Estatus: number;
    IdDocumentoAnterior: number;
    IdDocumentoNuevo: number;
    TipoEntradaSalida?: 'E' | 'S' | 'A';
}
